import { IButtonProps, PrimaryButton } from '@fluentui/react/lib/Button';
import { useId } from '@uifabric/react-hooks';
import loc from 'owa-localize';
import * as React from 'react';
import {
    AttachText,
    AttachTooltip,
    insertSplitButtonAriaDescribeBy,
    InsertText,
    InsertTooltip,
    MoreOptions,
} from './FilePickerPaneBottomPart.locstring.json';

const styles = require('./FilePickerInsertAttachButton.scss');

export interface FilePickerInsertAttachButtonProps {
    isDisabled: boolean;
    disabledAttachTooltip: string;
    onInsertClicked: () => void;
    onAttachClicked: () => void;
}

export function FilePickerInsertAttachButton(props: FilePickerInsertAttachButtonProps) {
    const insertLabel = loc(InsertText);
    const commonProps: IButtonProps = {
        className: styles.insertButton,
        onClick: props.onInsertClicked,
        ariaLabel: insertLabel,
        disabled: props.isDisabled,
        title: insertLabel,
    };

    const ariaDescriptionId = useId('insertSplitButton');
    const attachTitle: string = props.disabledAttachTooltip
        ? props.disabledAttachTooltip
        : loc(AttachTooltip);
    const buttonProps = props.onAttachClicked
        ? {
              ...commonProps,
              split: true,
              menuProps: {
                  items: [
                      {
                          key: 'FilePickerInsert',
                          text: insertLabel,
                          onClick: props.onInsertClicked,
                          title: loc(InsertTooltip),
                      },
                      {
                          key: 'FilePickerAttach',
                          text: loc(AttachText),
                          title: attachTitle,
                          disabled: props.disabledAttachTooltip != null,
                          onClick: props.onAttachClicked,
                      },
                  ],
              },
              splitButtonAriaLabel: loc(MoreOptions),
          }
        : commonProps;

    return (
        <div className={styles.insertAttach}>
            {
                <span className={styles.splitButtonAriaDescription} id={ariaDescriptionId}>
                    {loc(insertSplitButtonAriaDescribeBy)}
                </span>
            }
            <PrimaryButton {...buttonProps} aria-describedby={ariaDescriptionId}>
                {insertLabel}
            </PrimaryButton>
        </div>
    );
}
